import axios from 'axios';

const cepApi = axios.create({
    baseURL: "https://viacep.com.br/ws/",
})

export async function getCepInfo(cep) {
    return cepApi.get(`${cep}/json/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
            }
            return error;
        })
};





const cepServices = {
    getCepInfo,
}
export default cepServices;